import { IToolbar } from 'app/services/api5-service/api.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FIELD_HIDDEN_CLASS } from 'common/dynamic-form/utils/class-fields';
import { DocHelper } from 'utils/dochelper';

import { ToolbarProps } from './model/toolbar-props.interface';

import { ISPFieldConfig, ISPFieldType, ISPFormState } from '../../model';

/**
 * Get stream of wizard hidden state
 *
 * @param toolbar$
 */
function isToolbarHidden$(
  toolbar$: Observable<IToolbar | undefined>,
): Observable<boolean> {
  return toolbar$.pipe(map(toolbar => !toolbar));
}

/**
 * Get config props for toolbar field
 *
 * @param state - dynamic form state
 */
export function getToolbarProps(state: ISPFormState): ToolbarProps {
  const toolbar = DocHelper.getToolbar(state.docSubject.value);
  const toolbar$ = DocHelper.getToolbar$(state.docSubject);

  return {
    doc$: state.docSubject,
    elid$: state.docSubject.pipe(map(doc => DocHelper.elid(doc))),
    toolbar$,
    layoutPlace: 'header',
    order: -10,
    isHidden: !toolbar,
    isHidden$: isToolbarHidden$(toolbar$),
  };
}

/**
 * Get config for toolbar field
 *
 * @param state - dynamic form state
 */
export function getToolbarConfig(
  state: ISPFormState,
): ISPFieldConfig<ISPFieldType.Toolbar> | undefined {
  const props = getToolbarProps(state);

  // every time if there's no toolbar - it won't appear in runtime
  if (props.isHidden) {
    return undefined;
  }

  return {
    type: ISPFieldType.Toolbar,
    props,
    expressions: {
      'props.isHidden': props.isHidden$!,
      className: props.isHidden$!.pipe(
        map(isHidden => (isHidden ? FIELD_HIDDEN_CLASS : '')),
      ),
    },
  };
}
